import { gql } from 'apollo-boost'

import useMutation, { mutationTypes } from '@utils/graphqlUtils'

const MUTATION = gql`
  mutation($id: String!) {
    deleteOneInstallation(
      where: { id: $id }
    ) {
      id
    }
  }
`

export default () => (
  useMutation(MUTATION, `Instalação eliminada`, mutationTypes.DELETE)
)

